<template>
  <div 
    :class="[
      `layout--${overlay ? 'overlay' : 'full'}`,
      center && 'layout--center'
    ]"
  >
    <div
      v-if="wrapper"
      :class="[
        'layout__wrapper',
        size && `layout--size-${size}`
      ]"
    >
      <slot />
    </div>
    <slot v-else />
  </div>
</template>

<script setup>
const props = defineProps({
  size: {
    type: String,
    default: 'base',
    validator: (value) => ['base', 'wide', 'x-wide', 'xx-wide'].includes(value)
  },
  overlay: {
    type: Boolean,
    default: false
  },
  wrapper: {
    type: Boolean,
    default: false
  },
  center: {
    type: Boolean,
    default: false
  }
})
</script>
